import React, { forwardRef } from "react";
import { useFormState } from "react-final-form";
import { QuiButton } from "../../QuiButton/QuiButton.js";
export const QuiSubmitButton = forwardRef((props, ref) => {
    var _a;
    const { submitting, hasValidationErrors } = useFormState();
    // if disabled is not explicitly set, the button will still disable while submitting
    const disabled = (_a = props.disabled) !== null && _a !== void 0 ? _a : submitting;
    return React.createElement(QuiButton, Object.assign({}, props, { type: "submit", ref: ref, spinner: submitting, disabled: disabled, "aria-invalid": hasValidationErrors }));
});
QuiSubmitButton.displayName = "QuiSubmitButton";
